// // components/common/SkeletonLoader.jsx
// import React from 'react';

// export const DashboardStatsSkeleton = () => (
//   <div className="animate-pulse">
//     {/* Header Skeleton */}
//     <div className="flex justify-between items-center mb-6">
//       <div className="h-8 w-48 bg-gray-200 rounded"></div>
//       <div className="flex gap-4">
//         <div className="h-10 w-32 bg-gray-200 rounded"></div>
//         <div className="h-10 w-10 bg-gray-200 rounded"></div>
//       </div>
//     </div>

//     {/* Division Tabs Skeleton */}
//     <div className="border-b border-gray-200 mb-6">
//       <div className="flex space-x-8">
//         {[...Array(4)].map((_, i) => (
//           <div key={i} className="h-10 w-24 bg-gray-200 rounded mb-2"></div>
//         ))}
//       </div>
//     </div>

//     {/* Metric Cards Skeleton */}
//     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
//       {[...Array(3)].map((_, i) => (
//         <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <div className="flex items-start justify-between mb-4">
//             <div className="p-3 rounded-lg bg-gray-100 w-12 h-12"></div>
//             <div className="w-6 h-6 bg-gray-100 rounded"></div>
//           </div>
//           <div className="space-y-2">
//             <div className="h-4 w-24 bg-gray-200 rounded"></div>
//             <div className="h-8 w-32 bg-gray-300 rounded"></div>
//             <div className="h-4 w-20 bg-gray-200 rounded"></div>
//           </div>
//         </div>
//       ))}
//     </div>

//     {/* Stage Pipeline Skeleton */}
//     <div className="h-6 w-32 bg-gray-200 rounded mb-4"></div>
//     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//       {[...Array(7)].map((_, i) => (
//         <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <div className="space-y-3">
//             <div className="h-3 w-3 bg-gray-300 rounded-full"></div>
//             <div className="h-5 w-28 bg-gray-200 rounded"></div>
//             <div className="h-4 w-16 bg-gray-100 rounded"></div>
//             <div className="space-y-2">
//               <div className="h-3 w-full bg-gray-100 rounded"></div>
//               <div className="h-3 w-full bg-gray-100 rounded"></div>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// export const SalespersonDashboardSkeleton = () => (
//   <div className="space-y-6 p-6 animate-pulse">
//     {/* Header Skeleton */}
//     <div className="flex justify-between items-center">
//       <div>
//         <div className="h-8 w-96 bg-gray-200 rounded mb-2"></div>
//         <div className="h-4 w-64 bg-gray-100 rounded"></div>
//       </div>
//       <div className="flex gap-3">
//         {[...Array(3)].map((_, i) => (
//           <div key={i} className="h-10 w-32 bg-gray-200 rounded"></div>
//         ))}
//       </div>
//     </div>

//     {/* Summary Cards Skeleton */}
//     <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//       {[...Array(4)].map((_, i) => (
//         <div key={i} className="bg-gradient-to-br from-gray-200 to-gray-300 rounded-xl p-6">
//           <div className="flex items-center justify-between mb-4">
//             <div className="w-8 h-8 bg-gray-400 rounded"></div>
//             <div className="w-12 h-8 bg-gray-400 rounded"></div>
//           </div>
//           <div className="h-4 w-24 bg-gray-400 rounded"></div>
//         </div>
//       ))}
//     </div>

//     {/* Pipeline Overview Skeleton */}
//     <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//       <div className="h-6 w-40 bg-gray-200 rounded mb-4"></div>
//       <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
//         {[...Array(7)].map((_, i) => (
//           <div key={i} className="text-center p-4 rounded-lg border border-gray-200">
//             <div className="w-3 h-3 bg-gray-300 rounded-full mx-auto mb-2"></div>
//             <div className="h-3 w-16 bg-gray-200 rounded mx-auto mb-1"></div>
//             <div className="h-6 w-12 bg-gray-300 rounded mx-auto"></div>
//             <div className="h-3 w-14 bg-gray-100 rounded mx-auto mt-1"></div>
//           </div>
//         ))}
//       </div>
//     </div>

//     {/* Table Skeleton */}
//     <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//       <div className="p-6 border-b border-gray-200">
//         <div className="h-6 w-64 bg-gray-200 rounded"></div>
//       </div>
//       <div className="p-6">
//         {[...Array(5)].map((_, i) => (
//           <div key={i} className="flex items-center gap-4 py-4 border-b border-gray-100">
//             <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
//             <div className="flex-1">
//               <div className="h-5 w-32 bg-gray-200 rounded mb-2"></div>
//               <div className="h-3 w-48 bg-gray-100 rounded"></div>
//             </div>
//             <div className="h-6 w-24 bg-gray-200 rounded"></div>
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// );


// components/common/SkeletonLoader.jsx
import React from 'react';

// Base Skeleton Component with animation variants
const Skeleton = ({ className = '', variant = 'shimmer', rounded = 'rounded' }) => {
  const baseClasses = `relative overflow-hidden bg-gray-200 ${rounded}`;
  
  const getVariantClasses = () => {
    switch (variant) {
      case 'shimmer':
        return 'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_ease-in-out_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent';
      case 'pulse':
        return 'animate-pulse';
      case 'wave':
        return 'bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[size:200%_100%] animate-[wave_2s_ease-in-out_infinite]';
      default:
        return '';
    }
  };

  return <div className={`${baseClasses} ${getVariantClasses()} ${className}`} />;
};

// Enhanced Dashboard Stats Skeleton
export const DashboardStatsSkeleton = ({ variant = 'shimmer' }) => (
  <div>
    {/* Header Skeleton */}
    <div className="flex justify-between items-center mb-6">
      <Skeleton className="h-8 w-48" variant={variant} />
      <div className="flex gap-4">
        <Skeleton className="h-10 w-32" variant={variant} rounded="rounded-lg" />
        <Skeleton className="h-10 w-10" variant={variant} rounded="rounded-lg" />
      </div>
    </div>

    {/* Division Tabs Skeleton */}
    <div className="border-b border-gray-200 mb-6 overflow-hidden">
      <div className="flex space-x-8">
        {[...Array(4)].map((_, i) => (
          <div 
            key={i} 
            className="opacity-0 animate-[fadeInUp_0.5s_ease-out_forwards]"
            style={{ animationDelay: `${i * 0.1}s` }}
          >
            <Skeleton className="h-10 w-24 mb-2" variant={variant} />
          </div>
        ))}
      </div>
    </div>

    {/* Metric Cards Skeleton with Red Theme */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {[...Array(3)].map((_, i) => (
        <div 
          key={i} 
          className="opacity-0 animate-[fadeInScale_0.5s_ease-out_forwards]"
          style={{ animationDelay: `${i * 0.15}s` }}
        >
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-start justify-between mb-4">
              <Skeleton 
                className="p-3 w-12 h-12 bg-red-50" 
                variant={variant} 
                rounded="rounded-lg"
              />
              <Skeleton className="w-6 h-6" variant={variant} rounded="rounded" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-24" variant={variant} />
              <Skeleton className="h-8 w-32 bg-gray-300" variant={variant} />
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-4" variant={variant} rounded="rounded" />
                <Skeleton className="h-4 w-16" variant={variant} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Stage Pipeline Skeleton */}
    <Skeleton className="h-6 w-32 mb-4" variant={variant} />
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {[...Array(7)].map((_, i) => (
        <div 
          key={i} 
          className="opacity-0 animate-[fadeInUp_0.5s_ease-out_forwards]"
          style={{ animationDelay: `${(i + 3) * 0.05}s` }}
        >
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="space-y-3">
              <Skeleton className="h-3 w-3" variant={variant} rounded="rounded-full" />
              <Skeleton className="h-5 w-28" variant={variant} />
              <Skeleton className="h-4 w-16" variant={variant} />
              <div className="space-y-2">
                <div className="flex justify-between">
                  <Skeleton className="h-3 w-12" variant={variant} />
                  <Skeleton className="h-3 w-8" variant={variant} />
                </div>
                <div className="flex justify-between">
                  <Skeleton className="h-3 w-16" variant={variant} />
                  <Skeleton className="h-3 w-12" variant={variant} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Enhanced Salesperson Dashboard Skeleton
export const SalespersonDashboardSkeleton = ({ variant = 'shimmer' }) => (
  <div className="space-y-6 p-6">
    {/* Header Skeleton */}
    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
      <div>
        <Skeleton className="h-8 w-96 mb-2" variant={variant} />
        <Skeleton className="h-4 w-64" variant={variant} />
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <Skeleton className="h-10 w-64" variant={variant} rounded="rounded-lg" />
        <Skeleton className="h-10 w-32" variant={variant} rounded="rounded-lg" />
        <Skeleton className="h-10 w-24" variant={variant} rounded="rounded-lg" />
      </div>
    </div>

    {/* Summary Cards Skeleton with Gradient */}
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {[
        { from: 'from-red-400', to: 'to-red-500' },
        { from: 'from-blue-400', to: 'to-blue-500' },
        { from: 'from-green-400', to: 'to-green-500' },
        { from: 'from-purple-400', to: 'to-purple-500' }
      ].map((gradient, i) => (
        <div 
          key={i}
          className={`opacity-0 animate-[fadeInScale_0.5s_ease-out_forwards]`}
          style={{ animationDelay: `${i * 0.1}s` }}
        >
          <div className={`bg-gradient-to-br ${gradient.from} ${gradient.to} rounded-xl p-6`}>
            <div className="flex items-center justify-between mb-4">
              <Skeleton className="w-8 h-8 bg-white/30" variant="pulse" rounded="rounded" />
              <Skeleton className="w-12 h-8 bg-white/30" variant="pulse" rounded="rounded" />
            </div>
            <Skeleton className="h-4 w-24 bg-white/30" variant="pulse" rounded="rounded" />
          </div>
        </div>
      ))}
    </div>

    {/* Pipeline Overview Skeleton */}
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <Skeleton className="h-6 w-40 mb-4" variant={variant} />
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
        {[...Array(7)].map((_, i) => (
          <div 
            key={i}
            className="opacity-0 animate-[fadeIn_0.3s_ease-out_forwards]"
            style={{ animationDelay: `${i * 0.05}s` }}
          >
            <div className="text-center p-4 rounded-lg border border-gray-200">
              <Skeleton className="w-3 h-3 mx-auto mb-2" variant={variant} rounded="rounded-full" />
              <Skeleton className="h-3 w-16 mx-auto mb-1" variant={variant} />
              <Skeleton className="h-6 w-12 mx-auto" variant={variant} />
              <Skeleton className="h-3 w-14 mx-auto mt-1" variant={variant} />
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Table Skeleton */}
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="p-6 border-b border-gray-200">
        <Skeleton className="h-6 w-64" variant={variant} />
      </div>
      <div>
        {/* Table Header */}
        <div className="bg-gray-50 px-6 py-3 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <Skeleton className="h-4 w-32" variant={variant} />
            {[...Array(7)].map((_, i) => (
              <Skeleton key={i} className="h-4 w-20" variant={variant} />
            ))}
            <Skeleton className="h-4 w-24" variant={variant} />
            <Skeleton className="h-4 w-28" variant={variant} />
          </div>
        </div>
        {/* Table Rows */}
        {[...Array(5)].map((_, i) => (
          <div 
            key={i} 
            className="opacity-0 animate-[fadeInLeft_0.5s_ease-out_forwards] px-6 py-4 border-b border-gray-100"
            style={{ animationDelay: `${i * 0.1}s` }}
          >
            <div className="flex items-center gap-4">
              <Skeleton className="w-8 h-8" variant={variant} rounded="rounded-full" />
              <div className="flex-1">
                <Skeleton className="h-4 w-40 mb-1" variant={variant} />
              </div>
              {[...Array(7)].map((_, j) => (
                <div key={j} className="text-center">
                  <Skeleton className="h-4 w-12 mx-auto" variant={variant} />
                  <Skeleton className="h-3 w-16 mx-auto mt-1" variant={variant} />
                </div>
              ))}
              <Skeleton className="h-5 w-12" variant={variant} />
              <Skeleton className="h-5 w-24" variant={variant} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// New Follow-up Dashboard Skeleton
export const FollowUpDashboardSkeleton = ({ variant = 'shimmer' }) => (
  <div className="space-y-6">
    {/* Header Skeleton */}
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div className="opacity-0 animate-[fadeInLeft_0.5s_ease-out_forwards]">
        <Skeleton className="h-8 w-64 mb-2" variant={variant} />
        <Skeleton className="h-5 w-80" variant={variant} />
      </div>
      
      <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto opacity-0 animate-[fadeInRight_0.5s_ease-out_forwards]">
        <Skeleton className="h-10 w-full sm:w-64" variant={variant} rounded="rounded-lg" />
        <Skeleton className="h-10 w-full sm:w-40" variant={variant} rounded="rounded-lg" />
      </div>
    </div>

    {/* Summary Cards Skeleton */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {[
        { border: 'border-red-200', bg: 'bg-red-50' },
        { border: 'border-blue-200', bg: 'bg-blue-50' },
        { border: 'border-orange-200', bg: 'bg-orange-50' }
      ].map((style, i) => (
        <div 
          key={i}
          className={`opacity-0 animate-[fadeInScale_0.5s_ease-out_forwards]`}
          style={{ animationDelay: `${(i + 1) * 0.15}s` }}
        >
          <div className={`bg-white rounded-xl shadow-sm border-2 ${style.border} p-6`}>
            <div className="flex items-center justify-between mb-4">
              <div className={`p-3 ${style.bg} rounded-lg`}>
                <Skeleton className="h-6 w-6 bg-gray-300" variant="pulse" rounded="rounded" />
              </div>
              <Skeleton className="h-5 w-5" variant={variant} rounded="rounded" />
            </div>
            <Skeleton className="h-5 w-40 mb-3" variant={variant} />
            <Skeleton className="h-9 w-20 mb-2" variant={variant} />
            <Skeleton className="h-4 w-32" variant={variant} />
          </div>
        </div>
      ))}
    </div>

    {/* Follow-up List Skeleton */}
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 opacity-0 animate-[fadeIn_0.5s_ease-out_forwards_0.5s]">
      <div className="p-6 border-b border-gray-200">
        <Skeleton className="h-6 w-48" variant={variant} />
      </div>

      <div className="divide-y divide-gray-200">
        {[...Array(5)].map((_, i) => (
          <div 
            key={i} 
            className="p-6 opacity-0 animate-[fadeInUp_0.5s_ease-out_forwards]"
            style={{ animationDelay: `${(i + 5) * 0.1}s` }}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-4 flex-1">
                <div className="p-2 rounded-lg bg-red-50">
                  <Skeleton className="w-5 h-5 bg-red-200" variant="pulse" rounded="rounded" />
                </div>
                
                <div className="flex-1 space-y-3">
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-5 w-40" variant={variant} />
                    <Skeleton className="h-5 w-20" variant={variant} />
                    <Skeleton className="h-5 w-24" variant={variant} rounded="rounded-full" />
                  </div>
                  
                  <Skeleton className="h-4 w-64" variant={variant} />
                  
                  <div className="flex items-center gap-4">
                    <Skeleton className="h-4 w-24" variant={variant} />
                    <Skeleton className="h-4 w-20" variant={variant} />
                    <Skeleton className="h-4 w-28" variant={variant} />
                  </div>
                </div>
              </div>
              
              <Skeleton className="w-28 h-9 ml-4" variant={variant} rounded="rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Add keyframe animations to your global CSS or as a style tag
const animationStyles = `
  @keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
  
  @keyframes wave {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

// Add styles to document if not already added
if (typeof document !== 'undefined' && !document.getElementById('skeleton-animations')) {
  const style = document.createElement('style');
  style.id = 'skeleton-animations';
  style.textContent = animationStyles;
  document.head.appendChild(style);
}
